import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Modal } from 'bootstrap';

import { Data2Service } from '../../../../common/data2.service';
import { InfoboxService } from '../../../../common/infobox/infobox.service';

@Component({
	selector: 'app-drivers-salary-payments',
	templateUrl: './drivers-salary-payments.component.html',
	styleUrls: ['./drivers-salary-payments.component.css'],
})
export class DriversSalaryPaymentsComponent {
	editable = false;
	@Input() driverId;
	@Input() selectedMonth;
	@Input() paymentsData;
	@Output() closed = new EventEmitter();
	@Output() calculate = new EventEmitter();
	paymentMethod: Array<any> = [
		{ id: 0, name: 'Przelew' },
		{ id: 1, name: 'Gotówka' },
	];
	taxSalary: Array<any> = [];
	itemToRemove;

	constructor(
		private readonly api: Data2Service,
		private readonly infobox: InfoboxService,
	) {}

	private objectEdit(data) {
		this.api.put('/driversSalaryPayments/' + data.id + '/', data, (result, error) => {
			if (error) {
				return;
			}
			this.calculate.emit();
		});
	}

	addPos() {
		const data = {
			id: null,
			driver: this.driverId.id,
			salaryMonth: this.selectedMonth + '-01',
			value: null,
			paymentMethod: null,
			comment: null,
			editable: true,
			currency: 'PLN',
		};
		this.paymentsData.push(data);
	}

	save(data) {
		data.editable = false;
		if (data.id) {
			this.objectEdit(data);
			return;
		}
		this.objectAdd(data);
	}

	private objectAdd(data) {
		this.api.post('/driversSalaryPayments', data, (result, error) => {
			if (error) {
				return;
			}
			this.calculate.emit();
			return (data.id = result.data);
		});
	}

	dialogOpen() {
		new Modal(document.getElementById('driversSalaryPaymentsModal')).show();
	}

	dialogClose(): void {
		const modal = Modal.getInstance(document.getElementById('driversSalaryPaymentsModal'));
		if (!modal) {
			return;
		}
		modal.hide();
	}

	deleteAsk(data) {
		this.itemToRemove = data;
		this.dialogClose();
		this.deleteDialogOpen();
	}

	deleteConfirm() {
		this.deleteDialogClose();
		if (!this.itemToRemove.id) {
			this.removeRow(this.itemToRemove);
			return;
		}
		this.api.del(
			'/driversSalaryPayments/' +
				this.itemToRemove.id +
				'/' +
				this.itemToRemove.driver +
				'/' +
				this.itemToRemove.salaryMonth +
				'/',
			(result, error) => {
				if (error) {
					return;
				}
				this.removeRow(this.itemToRemove);
				this.calculate.emit();
			},
		);
	}

	private removeRow(data) {
		this.paymentsData = this.paymentsData.filter((obj) => obj != data);
	}

	deleteDialogOpen(): void {
		new Modal(document.getElementById('driversSalaryPaymentsQuestion')).show();
	}

	deleteDialogClose(): void {
		const modal = Modal.getInstance(document.getElementById('driversSalaryPaymentsQuestion'));
		if (!modal) {
			return;
		}
		modal.hide();
	}
}
